import React, { useState } from 'react';
import { MoreVert as MoreVertIcon } from '@mui/icons-material';
import { T, fontBody } from '../tokens';

export default function TemplateCardMenu({ template, onToggleStatus, onDelete, toggling }) {
  const [open, setOpen] = useState(false);
  // Show delete for: custom automations, channel defaults, and the legacy comment_dm type.
  // The only un-deletable ones are non-channel-default system templates (none of the above).
  const canDelete = template.templateType === 'custom'
    || template.isChannelDefault
    || template.templateType === 'comment_dm';

  return (
    <div style={{ position: 'relative' }}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        style={{
          border: 'none', background: 'transparent', cursor: 'pointer',
          padding: 4, display: 'flex', color: T.slateLight,
        }}
      >
        <MoreVertIcon sx={{ fontSize: 18 }} />
      </button>
      {open && (
        <>
          <button
            type="button"
            aria-label="Close menu"
            onClick={() => setOpen(false)}
            style={{ position: 'fixed', inset: 0, border: 'none', background: 'transparent', cursor: 'default', zIndex: 10 }}
          />
          <div style={{
            position: 'absolute', right: 0, top: '100%', marginTop: 4, zIndex: 11,
            background: T.card, border: `1px solid ${T.line}`, borderRadius: 10,
            boxShadow: '0 8px 24px rgba(11,18,32,0.12)', minWidth: 160, overflow: 'hidden',
          }}
          >
            <MenuItem
              label={template.status === 'Active' ? 'Pause automation' : 'Activate automation'}
              disabled={toggling}
              onClick={() => { onToggleStatus(template); setOpen(false); }}
            />
            {canDelete && onDelete && (
              <MenuItem
                label="Delete automation"
                danger
                disabled={toggling}
                onClick={() => { onDelete(template); setOpen(false); }}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
}

function MenuItem({ label, onClick, disabled, danger }) {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      style={{
        width: '100%', textAlign: 'left', border: 'none', background: 'transparent',
        padding: '10px 14px', fontFamily: fontBody, fontSize: 13, fontWeight: 500,
        color: danger ? '#DC2626' : T.ink, cursor: disabled ? 'not-allowed' : 'pointer',
      }}
    >
      {label}
    </button>
  );
}
